import { getUser, saveUser } from "../actions/auth";
import CompanyActions from "../actions/companies";
import { getActionHandler, getInitialState } from "../helpers/crudReducers";

const initialState = getInitialState("COMPANIES");
const CRUD_ACTION_HANDLERS = {
  ...getActionHandler("COMPANIES"),
  [CompanyActions.OBJECT_SAVE_FULFILLED]: (state, action) => {
    const company = action.payload.data;
    const user = getUser();
    if (company.id === user?.Company?.id) {
      saveUser({ ...user, Company: company });
    }
    return { ...state, readyState: CompanyActions.OBJECT_SAVE_FULFILLED, object: company };
  },
};

export default function roles(state = initialState, action) {
  const handler = CRUD_ACTION_HANDLERS[action.type];
  return handler ? handler(state, action) : state;
}
